import { occFetch, occUrl } from "~/app/api/occ/occFetch";

const apiUrl = occUrl("/account/marketingConsent");

export function sendMarketingConsent(consent: boolean) {
  return occFetch(apiUrl, {
    method: "POST",
    body: JSON.stringify({ marketingConsent: consent }),
    cache: "no-cache",
    headers: {
      "content-type": "application/json",
    },
  });
}
